import * as React from "react";
import { connect } from "react-redux";
import { DatePicker } from "antd";
// 日期范围选择
const RangePicker = DatePicker.RangePicker;
// 轻量级的JavaScript日期库，用于解析，验证，操作和格式化日期。
import moment from "moment";

interface IDateRangePickerProps {
  value?: any;
  field?: any;
  extField1?: any;
  modelName?: any;
  onChange?: any;
  setValue?: any;
  // 是否显示今天之后的日期
  isShowAfterToday?: boolean;
  // 默认不显示2010之前的日期
  noShowBefore2010Date?: boolean;
  CreateForm: any;
  // 自定义日期范围快捷键
  ranges?: any;
  width?: any;
  disabledDate?: any;
  // 用于找到父节点的选择器
  containerBody?: any;
  //  获取redux中保存的值
  getValue?: any;
}

class DateRangePicker extends React.Component<IDateRangePickerProps, any> {
  state = {
    disabledDate: true
  };
  constructor(props: IDateRangePickerProps) {
    super(props);
    if (this.props.disabledDate != null && this.props.disabledDate === false)
      this.state.disabledDate = false;
  }

  getValue = (model, field) => {
    for (const key in this.props.CreateForm[model]) {
      if (key === field) {
        return this.props.CreateForm[model][key];
      } else {
        continue;
      }
    }
    return null;
  };

  getContainer = () => {
    const containerBody = this.props.containerBody;
    if (containerBody) {
      return document.querySelector(containerBody) || document.body;
    } else {
      return document.body;
    }
  };

  ranges = () => {
    const thisWeekMonday = moment().subtract(moment().day() - 1, "days"); //周一日期
    let thisWekkSunday = moment(thisWeekMonday).add(6, "days"); //周日日期
    let thisMonthEndDay = moment().endOf("month");
    const currentDate = moment();
    // console.log("isShowAfterToday", this.props.isShowAfterToday);
    if (!this.props.isShowAfterToday) {
      thisWekkSunday = currentDate;
      thisMonthEndDay = currentDate;
    }
    return {
      当天: [moment(), moment()],
      本周: [thisWeekMonday, thisWekkSunday],
      // 近三天: [moment().subtract(2, "days"), moment()],
      // 近一周: [moment().subtract(6, "days"), moment()],
      本月: [moment().startOf("month"), thisMonthEndDay]
    };
  };

  render() {
    const onChangeRangePicker = (data, dateString) => {
      let rangePickerData = {};
      rangePickerData[`${this.props.field}`] = dateString[0];
      rangePickerData[`${this.props.extField1}`] = dateString[1];

      this.props.setValue({
        formInfo: rangePickerData,
        model: this.props.modelName
      });
    };

    let beginDate: any = this.props.value;
    let endDate: any;

    if (this.props.getValue) {
      const _dateRange: any = this.props.getValue();

      beginDate = _dateRange[0];
      endDate = _dateRange[1];
    } else {
      endDate = this.getValue(this.props.modelName, this.props.extField1);
    }

    let rangePickerValue: any = [];
    if (beginDate && endDate) {
      const dateFormat = "YYYY-MM-DD";
      rangePickerValue = [
        moment(beginDate, dateFormat),
        moment(endDate, dateFormat)
      ];
    }

    const noShowBefore2010Date = this.props.noShowBefore2010Date;
    const isShowAfterToday = this.props.isShowAfterToday;
    let disabledDate = date => {
      let isReturn = false;
      // 设置2010-12-31之前的日期不可以选择
      if (noShowBefore2010Date == undefined || noShowBefore2010Date) {
        const beginDate = moment("2010-12-31");
        isReturn = date <= beginDate;
        if (isReturn) return true;
      } // 设置今天之后的日期不可以选择
      if (!isShowAfterToday) {
        const beginDate = moment(new Date().getTime());
        isReturn = date > beginDate;
        if (isReturn) return true;
      }
      return isReturn;
    };

    // if (!this.state.disabledDate) {
    //   disabledDate = date => {
    //     return false;
    //   };
    // }

    // 设置日期范围快捷键
    const settRanges = () => {
      if (this.props.ranges) {
        return this.props.ranges();
      } else {
        return this.ranges();
      }
    };

    return (
      <RangePicker
        // style={{ width: this.props.width || 220 }}
        style={{ width: this.props.width || "calc(100% - 60px)" }}
        ranges={settRanges()}
        value={rangePickerValue}
        disabledDate={disabledDate}
        getCalendarContainer={this.getContainer}
        onChange={this.props.onChange || onChangeRangePicker}
      />
    );
  }
}

// export default DateRangePicker;
const mapState = state => ({
  CreateForm: state.antDemo
});

const mapDispatch = dispatch => {
  return {
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(DateRangePicker);
